import { Injectable } from '@angular/core';
import { ApiUrls } from "../config/api-urls";
import { CommonHttpService } from './common-http.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class AzureService {

  constructor(
    private commonHttpService: CommonHttpService,
    private apiUrls: ApiUrls,
    private commonService: CommonService
  ) { }

  public uploadImage(formData: FormData) {
    return this.commonHttpService.postFormData(this.apiUrls.user.uploadImage, formData)
  }
}
